import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";

import { SvgTransactions, SvgCollapse } from "../../../components/svg-icon";
import { paths } from "../../../routes/paths";
import Logo from "../../../components/brand/logo";

const Item = ({ title, to, icon, isActive }) => {
  return (
    <MenuItem
      active={isActive}
      className={`pro-menu-item ${isActive ? "active" : ""}`}
      style={{
        color: "#C6DDF7",
      }}
      icon={icon}
      component={<Link to={to} />}
    >
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: isActive ? 600 : 400,
        }}
      >
        {title}
      </Typography>
    </MenuItem>
  );
};

const ProSidebar = ({ isCollapsed, setIsCollapsed }) => {
  const { pathname } = useLocation();

  const isTransactionsActive = pathname.startsWith(paths.transactions);

  return (
    <Box
      sx={{
        background: "#04326B !important",
        overflowX: "hidden",
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        zIndex: 1100,

        "& .css-8u2p5i": {
          paddingLeft: "0px !important",
        },
        "& .css-dip3t8": {
          background: "#04326B !important",
        },

        "& .pro-menu-item.active:not(.parent-submenu)": {
          color: "#fff !important",
          border: `${!isCollapsed ? "1px solid #034592" : "none"}`,
          borderRadius: "4px",
          background: `${!isCollapsed ? "#034592" : "none"}`,
        },
      }}
    >
      <Sidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO / COLLAPSE */}
          <MenuItem>
            {isCollapsed ? (
              <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                }}
              >
                <SvgCollapse collapsed={isCollapsed} />
              </button>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Logo iconColor="#fff" textColor="#fff" width="120px" />
                <button
                  onClick={() => setIsCollapsed(!isCollapsed)}
                  style={{
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                  }}
                >
                  <SvgCollapse collapsed={isCollapsed} />
                </button>
              </Box>
            )}
          </MenuItem>

          {/* MENU ITEMS */}
          <Box mt={6}>
            <Item
              title="Transactions"
              to={paths.transactions}
              icon={
                <SvgTransactions
                  color={isTransactionsActive ? "#2F80ED" : "#fff"}
                />
              }
              isActive={isTransactionsActive}
            />
          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default ProSidebar;
